function _hasPhoneCommand(name) {
	if (process.env.PLATFORM === "mobile") {
		return typeof window.App !== "undefined" &&
			window.App.availablePhoneCommands &&
			window.App.availablePhoneCommands[name] &&
			typeof window.App.phoneCommand !== "undefined";
	}

	return false;
}

function AppPhoneCommand(name, params, callback) {
	if (_hasPhoneCommand(name)) {
		return window.App.phoneCommand(name, { parameters: params, cb: callback });
	}

	return null;
}

export default AppPhoneCommand;

export const hasPhoneCommand = _hasPhoneCommand;



// WEBPACK FOOTER //
// ./src/shared/util/AppPhoneCommand.js